import { creatorbase } from '@round/api';
import { CurrencyOption } from 'contexts/OptionsContext/useCurrencies';
import { AgencyPayeeOption } from 'Modules/Plans/Finance/Payee/hooks/useAgencyPayeeSelect';
import { PayeeOption } from 'Modules/Plans/Finance/Payee/hooks/usePayeeSelect';
import * as yup from 'yup';

export type Provider = creatorbase.PaymentProvider;

export type SubmitType = 'save' | 'submit' | null;

export type FormValues = {
    cost: number | null | undefined;
    currency: CurrencyOption | undefined;
    notes: string | undefined;
    fileUpload: File | '' | undefined;
    submitType: SubmitType | null;
    provider: Provider | null | undefined;
    paypalEmail: string | undefined;
    payee: PayeeOption | null | undefined;
    agencyPayee: AgencyPayeeOption | null | undefined;
};

export const validationSchema = yup.object({
    cost: yup.number().required('Cost is required'),
    notes: yup.string().when(['submitType', 'provider'], {
        is: (submitType: SubmitType | null, provider: Provider | null | undefined) =>
            submitType === 'submit' && provider === 'OTHER',
        then: (schema) => schema.min(1, 'Payment notes are required').required('Payment notes are required'),
        otherwise: (schema) => schema.optional(),
    }),
    paypalEmail: yup.string().when(['provider', 'submitType'], {
        is: (provider: Provider | null | undefined, submitType: SubmitType | null) =>
            provider === 'PAYPAL' && submitType === 'submit',
        then: (schema) => schema.email('Invalid email').required('PayPal email is required'),
        otherwise: (schema) => schema.optional(),
    }),
    payee: yup
        .object()
        .when(['provider', 'submitType'], {
            is: (provider: Provider | null | undefined, submitType: SubmitType | null) =>
                provider === 'TIPALTI' && submitType === 'submit',
            then: (schema) => schema.required('Payee is required'),
            otherwise: (schema) => schema.optional(),
        })
        .nullable(),
    agencyPayee: yup
        .object()
        .when(['provider', 'submitType'], {
            is: (provider: Provider | null | undefined, submitType: SubmitType | null) =>
                provider === 'CREATOR_AGENCY' && submitType === 'submit',
            then: (schema) => schema.required('Agency is required'),
            otherwise: (schema) => schema.optional(),
        })
        .nullable(),
});
